/**
 * Bug #452
 * @Author Santhosh Kumar
 * @Date 21 June 2021
 */
import axios from "axios";
import { API_GET_APPOINTMENT_SLOT, API_BOOK_APPOINTMENT, API_LIST_APPOINTMENT, API_VIRTUAL_GET_PROFILE_STATUS, API_APPOINTMENT_PAYMENT, API_GET_SAVED_CARDS, API_APPOINTMENT_REMINDER, API_LIST_APPOINTMENT_REMINDER, API_DELETE_APPOINTMENT_REMINDER, API_DELETE_SAVED_CARD, API_SELECT_PROVIDERS, API_SELECT_APPTTYPES, API_RECALL_REMINDER, API_LIST_RECALL_REMINDER, API_DELETE_RECALL_REMINDER } from 'api/endpoint';
import moment from "moment";

export const getAppointmentSlot = (data) => {
  return axios.post(API_GET_APPOINTMENT_SLOT, data);
};

export const bookAppointmentSlot = (data) => {
  return axios.post(API_BOOK_APPOINTMENT, data);
};
// #bug No 502 @Author Jithin Kuriakose 22 /07 /2021 
export const listAppointment = (pageNo, pageSize = 10, type) => {
  return axios.post(API_LIST_APPOINTMENT + "?pageNo=" + pageNo + "&pageSize=" + pageSize + "&type=" + type + (type != '1' ? "&todayDate=" + moment(new Date()).format('YYYY-MM-DD') : "")); /**Bug#723 by Linda Susan Raju on 04Mar2022 */
};

/*** End ***/

/** Bug#576 @Author: Linda Susan Raju @Date: 25 Aug 2021 */
export const virtualProfileStatus = () => {
  return axios.post(API_VIRTUAL_GET_PROFILE_STATUS, {});
};
/**
 * Bug #611 
 * @author Jithin Kuriakose
 * 23 Sept 2021
*/
export const addAppointmentPayment = (data) => {
  return axios.post(API_APPOINTMENT_PAYMENT, data);
};
/*End Bug #611 */

/**
 * Bug #732 
 * @author Aby Joseph
 * 18 Jan 2022
*/
export const getSavedCards = () => {
  return axios.get(API_GET_SAVED_CARDS, { params: {} });
};
/*End Bug #732 */

/** Bug #782
 * Midhila Velayudhan 
 * 22 march 2022
 */
export const saveAppointmentReminder = (data) => {
  return axios.post(API_APPOINTMENT_REMINDER, data)
}

export const saveRecallReminder = (data) => {
  return axios.post(API_RECALL_REMINDER, data)
}
/** Bug 782 @Author Anupama @Date 24 Mar 2022 */
export const listAppointmentReminder = (data) => {
  return axios.get(API_LIST_APPOINTMENT_REMINDER, data)
}
/**End  Bug #782*/

export const listRecallReminder = (data) => {
  return axios.get(API_LIST_RECALL_REMINDER, data)
}
/** Bug 782 @Author Anupama @Date 24 Mar 2022 */
export const deleteAppointmentReminder = (params) => {
  return axios.delete(API_DELETE_APPOINTMENT_REMINDER, { params })
}
export const deleteRecallReminder = (params) => {
  return axios.delete(API_DELETE_RECALL_REMINDER, { params })
}
/**End  Bug #782*/
/**Bug #881 - Implement delete saved card functionality @Author Jithin Kuriakose @date 12May2022 */
export const deleteSavedCards = (params) => {
  return axios.delete(API_DELETE_SAVED_CARD, { params })
}


//End Bug #881
export const setSelectProviders = (portalAccountId) => {
  return axios.get(API_SELECT_PROVIDERS, {
    params: {
      portalAccountId: portalAccountId,
    }
  })
};


export const setSelectApptTypes = (portalAccountId) => {
  return axios.get(API_SELECT_APPTTYPES, {
    params: {
      portalAccountId: portalAccountId
    }
  })
};

/**
 * 
 * @param portalAccountId Get Providers for Appointment Schedule Configuration
 * @returns 
 */

export const getSelectProvidersfromScheduleConfig = (params) => {
  return axios.get(API_SELECT_PROVIDERS, {
    params: params
  })
};